import { render, staticRenderFns } from "./ResourcesList.vue?vue&type=template&id=22786c7a"
import script from "./ResourcesList.vue?vue&type=script&lang=js"
export * from "./ResourcesList.vue?vue&type=script&lang=js"
import style0 from "./ResourcesList.vue?vue&type=style&index=0&id=22786c7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports